import { SubmissionError } from 'redux-form';
import sw from 'stopword';

export function handleFormErrors(error) {
  if (error.response) {
    throw new SubmissionError(error.response.data.errors);
  } else {
    console.log(error);
  }
}

export function formatTopImage(value) {
  if (!value) {
    return '';
  }
  if (typeof value === 'object') {
    return value.original.url;
  }
  return value;
}

export function slugify(text) {
  if (!text) {
    return '';
  }
  const stripped = sw.removeStopwords(text.split(' ')).join(' ');
  return stripped.toString().substring(0, 60).toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')       // Remove all non-word chars
    .replace(/--+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

export function normalizeQuotes(val) {
  let s = val.replace(/\u201c/g, '"');
  s = s.replace(/\u201d/g, '"');
  return s;
}

export function generateEntrySlug(entry, isAmp, full = false) {
  if (!entry.is_blitz) return entry.url;
  return entry.type === 'article'
  ? `${full ? 'https://blitzesports.com' : ''}/${entry.esport}${isAmp ? '/amp' : ''}/article/${entry.id}/${slugify(entry.title)}`
  : `${full ? 'https://blitzesports.com' : ''}/${entry.esport}${isAmp ? '/amp' : ''}/video/${entry.id}/${slugify(entry.title)}`;
}


// WEBPACK FOOTER //
// ./src/cms/form/utils.js